export type Product = {
  slug: string;
  name: string;
  title: string;
  teaser: string;
  image: string;
  description: string;
  features: string[];
  variants: { label: string; value: string }[];
};

export const products: Product[] = [
  {
    slug: "tuerdruecker-stifte",
    name: "Türdrücker-Stifte",
    title: "Türdrücker-Stifte",
    teaser: "Verbindungsstifte für Türdrückergarnituren – passgenau, maßhaltig und dauerhaft belastbar.",
    image:
      "https://www.franz-drexelius.de/wp-content/themes/agency/images/drexelius/teaser_prod_01.png",
    description:
      "Unsere Türdrücker-Stifte sind das Herzstück jeder Drückergarnitur. Sie verbinden Drücker und Schloss zuverlässig und übertragen das Drehmoment dauerhaft, ohne zu verwinden. Gefertigt aus hochwertigem Stahl, präzise gedreht und auf Wunsch vernickelt oder verzinkt, erfüllen sie die Anforderungen des täglichen Einsatzes im Objekt- und Wohnungsbau.",
    features: [
      "Präzise Drehtechnik mit engen Toleranzen",
      "Gehärteter bzw. vergüteter Stahl für hohe Dauerbelastung",
      "Oberflächen vernickelt, verzinkt oder brüniert lieferbar",
      "Sonderlängen und Sonderkopfformen auf Anfrage",
    ],
    variants: [
      { label: "Werkstoff", value: "Stahl, automatengeeignet" },
      { label: "Oberfläche", value: "vernickelt / verzinkt / brüniert" },
      { label: "Durchmesser", value: "ab 6 mm" },
      { label: "Längen", value: "nach Zeichnung und Muster" },
    ],
  },
  {
    slug: "wechsel-schlossstifte",
    name: "Wechsel-Schlossstifte",
    title: "Wechsel-Schlossstifte",
    teaser: "Stifte für Wechselschlösser – für die schnelle und sichere Umstellung von Schließanlagen.",
    image:
      "https://www.franz-drexelius.de/wp-content/themes/agency/images/drexelius/teaser_prod_02.png",
    description:
      "Wechsel-Schlossstifte kommen überall dort zum Einsatz, wo Schließzylinder oder Schlosssysteme im Bestand ausgetauscht werden müssen. Sie gleichen unterschiedliche Bohrbilder und Tiefen aus und stellen eine formschlüssige, spielfreie Verbindung her. Unsere Fertigung garantiert gleichbleibende Maßhaltigkeit auch bei großen Serien.",
    features: [
      "Für Wechselschlösser und Umbaugarnituren geeignet",
      "Formschlüssige, spielfreie Passung",
      "Gleichbleibende Qualität auch bei großen Stückzahlen",
      "Kundenspezifische Abmessungen nach Muster",
    ],
    variants: [
      { label: "Werkstoff", value: "Stahl bzw. Edelstahl" },
      { label: "Oberfläche", value: "vernickelt / blank" },
      { label: "Ausführung", value: "zylindrisch oder mit Ansatz" },
      { label: "Verpackung", value: "Mengen nach Vereinbarung" },
    ],
  },
  {
    slug: "psw-stifte",
    name: "PSW-Stifte",
    title: "PSW-Stifte",
    teaser: "PSW-Stifte mit gerippter Oberfläche für dauerhaft festen Sitz im Profilzylinderbereich.",
    image:
      "https://www.franz-drexelius.de/wp-content/themes/agency/images/drexelius/teaser_prod_03.png",
    description:
      "Unsere PSW-Stifte besitzen eine gerippte bzw. profilierte Oberfläche, die einen dauerhaft festen Sitz im Bauteil gewährleistet und ein Verdrehen wirksam verhindert. Sie sind die ideale Lösung für Anwendungen, bei denen eine hohe Verdrehsicherheit und eine definierte Auszugs- bzw. Einpresskraft gefordert sind.",
    features: [
      "Gerippte Oberfläche für verdrehsicheren Sitz",
      "Definierte Einpress- und Auszugskräfte",
      "Konstante Rippengeometrie über die gesamte Serie",
      "Werkstoff und Rippenform nach Kundenvorgabe",
    ],
    variants: [
      { label: "Werkstoff", value: "Stahl, vergütet" },
      { label: "Oberfläche", value: "gerippt, vernickelt möglich" },
      { label: "Rippen", value: "Anzahl und Teilung nach Vorgabe" },
      { label: "Toleranz", value: "eng toleriert" },
    ],
  },
  {
    slug: "musterkarten-stift",
    name: "Musterkarten-Stift",
    title: "Musterkarten-Stift",
    teaser: "Befestigungsstifte für Musterkarten – die saubere Lösung zur Präsentation von Beschlägen.",
    image:
      "https://www.franz-drexelius.de/wp-content/themes/agency/images/drexelius/teaser_prod_04.png",
    description:
      "Der Musterkarten-Stift dient der sicheren und zugleich ansprechenden Befestigung von Beschlägen, Drückern und Zubehör auf Musterkarten und Präsentationsbögen. Er hält das Ausstellungsstück zuverlässig an seinem Platz und lässt sich sauber und ohne Beschädigung der Karte montieren.",
    features: [
      "Saubere Befestigung ohne Beschädigung der Musterkarte",
      "Für Beschläge, Drücker und Zubehörteile geeignet",
      "Große Serien zu attraktiven Konditionen",
      "Auch als komplette Musterkarten-Bestückung lieferbar",
    ],
    variants: [
      { label: "Werkstoff", value: "Stahl / Kunststoff-Kombination" },
      { label: "Oberfläche", value: "vernickelt / messingfarben" },
      { label: "Ausführung", value: "nach Musterkarten-Typ" },
      { label: "Menge", value: "ab kleinen Losen lieferbar" },
    ],
  },
  {
    slug: "vierkant-stifte",
    name: "Vierkant-Stifte",
    title: "Vierkant-Stifte",
    teaser: "Vierkant-Stifte als formschlüssige Verbindung zwischen Drücker und Schloss.",
    image:
      "https://www.franz-drexelius.de/wp-content/themes/agency/images/drexelius/teaser_prod_05.png",
    description:
      "Vierkant-Stifte stellen eine formschlüssige, verdrehsichere Verbindung zwischen Drücker und Schloss her. Durch die präzise Vierkantbearbeitung sitzen sie exakt in der Aufnahme und übertragen das Drehmoment verlustfrei. Erhältlich in gängigen Vierkantmaßen sowie in Sonderabmessungen nach Zeichnung.",
    features: [
      "Formschlüssige, verdrehsichere Verbindung",
      "Präzise Vierkantbearbeitung mit scharfen Kanten",
      "Gängige Vierkantmaße ab Lager bzw. kurzfristig",
      "Sonderabmessungen nach Zeichnung oder Muster",
    ],
    variants: [
      { label: "Werkstoff", value: "Stahl / Edelstahl" },
      { label: "Vierkant", value: "7 / 8 / 9 / 10 mm" },
      { label: "Oberfläche", value: "vernickelt / verzinkt / brüniert" },
      { label: "Längen", value: "nach Vorgabe" },
    ],
  },
  {
    slug: "vierkant-stifte-abgesetzt",
    name: "Vierkant-Stifte abgesetzt",
    title: "Vierkant-Stifte abgesetzt",
    teaser: "Abgesetzte Vierkant-Stifte für unterschiedliche Aufnahmemaße innerhalb einer Garnitur.",
    image:
      "https://www.franz-drexelius.de/wp-content/themes/agency/images/drexelius/teaser_prod_06.png",
    description:
      "Abgesetzte Vierkant-Stifte weisen zwei unterschiedliche Querschnitte auf und überbrücken damit verschieden große Aufnahmen innerhalb einer Garnitur. So lassen sich Drücker und Schloss mit unterschiedlichen Vierkantaufnahmen sicher und verdrehsicher miteinander verbinden – die Lösung für typische Sonderfälle im Beschlagbau.",
    features: [
      "Zwei Vierkantmaße in einem Stift vereint",
      "Ideal bei unterschiedlichen Aufnahmen von Drücker und Schloss",
      "Verdrehsichere, spielfreie Kraftübertragung",
      "Abmessungen und Absatzlänge nach Kundenwunsch",
    ],
    variants: [
      { label: "Werkstoff", value: "Stahl / Edelstahl" },
      { label: "Vierkant", value: "kombiniert, z. B. 8 auf 9 mm" },
      { label: "Oberfläche", value: "vernickelt / verzinkt / brüniert" },
      { label: "Absatzlänge", value: "nach Vorgabe" },
    ],
  },
];

export const contactDetails = {
  company: "Franz Drexelius Metallverarbeitung GmbH",
  phone: "0 27 21 / 72 37",
  phoneHref: "tel:+4927217237",
  fax: "0 27 21 / 69 42",
  location: "Finnentrop-Heggen",
  street: "Zum Elberskamp 5",
  city: "57413 Finnentrop-Heggen",
  postOffice: "Postfach 660",
  postalCode: "57405 Finnentrop",
  email: "vertrieb@franz-drexelius.de",
  register: "HRB 5935",
  registerCourt: "Amtsgericht Siegen",
  director: "Dieter Quast",
  vatId: "DE 126 181 095",
};